import { useState, useCallback } from 'react';
import { ClientDTO, IClientIds, getClientByIds, getSelectedOUClients } from 'wisestep-api';

const useFetchClients = (organizationalUnitId, allClientsList) => {
  const [isLoading, setLoading] = useState(false);
  const [selectedClientsList, setSelectedClientsList] = useState<ClientDTO[]>([]);
  const [unSelectedClientsList, setunSelectedClientsList] = useState<ClientDTO[]>([]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getSelectedOUClients(organizationalUnitId ?? '');
      const responseData = response?.data || [];
      const ids = responseData.map((item) => item?.clientId);
      const payload: IClientIds = {
        ids: ids,
      };
      const res = await getClientByIds(payload);
      setSelectedClientsList(res?.data ?? []);
      const savedIds = new Set(ids);
      const unsavedList = allClientsList.filter((item) => !savedIds.has(item?.id));
      setunSelectedClientsList(unsavedList);
    } catch (error) {
      setSelectedClientsList([]);
      setunSelectedClientsList(allClientsList);
    } finally {
      setLoading(false);
    }
  }, [organizationalUnitId, allClientsList]);
  return { isLoading, selectedClientsList, unSelectedClientsList, fetchData };
};

export default useFetchClients;
